import { Location } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input, numberAttribute, signal } from '@angular/core';
import { ConsultingReservationService, Mode } from 'src/app/components/consulting-reservation';
import { Step1Component } from 'src/app/components/consulting-reservation/step1/step1.component';
import { Step2SimpleComponent } from 'src/app/components/consulting-reservation/step2-simple/step2.component';

@Component({
  selector: 'app-lp-consulting-reservation',
  imports: [
    Step1Component,
    Step2SimpleComponent
  ],
  templateUrl: './lp-consulting-reservation.component.html',
  styleUrl: './lp-consulting-reservation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpConsultingReservationComponent {
  readonly #location = inject(Location);
  readonly #reservationService = inject(ConsultingReservationService);

  readonly completeUrl = input.required<string>();
  readonly lpType = input.required<string>();
  readonly discount = input(10, { transform: numberAttribute });
  readonly isColorful = input(false, { alias: 'colorful', transform: booleanAttribute });

  readonly mode = signal<Mode>('step1');

  constructor() {
    this.#parseQuery();
    this.#location.onUrlChange(() => {
      this.#parseQuery();
    });
  }

  next() {
    this.mode.set('step2');
    localStorage.removeItem('reservedAt');
  }

  complete() {
    const counseling = sessionStorage.getItem('counseling');
    const value = JSON.parse(counseling!);
    this.#reservationService.reserve(value)
      .subscribe({
        next: () => {
          sessionStorage.removeItem('counseling');
          window.location.href = this.completeUrl();
        },
        error: err => {
          if (err.status === 409) {
            alert('既にお申込みがあります。\n\nご予約内容（お名前やメールアドレス）に不備があった場合や、カウンセリング日時の確認・変更をご希望の場合は、夢カナ留学の下記電話番号までお問い合わせください。\n\n03-5050-0802');
          }
        }
      });
  }

  #parseQuery() {
    const params = new URLSearchParams(window.location.search);
    this.mode.set(params.get('step') as Mode ?? 'step1');
  }
}
